import { useContext } from "react";
import { WeatherContext } from "../providers";

const useWeather = () => {
  const weatherContext = useContext(WeatherContext);

  if (!weatherContext) {
    throw new Error("useWeather must be used within an WeatherProvider");
  }
  return weatherContext;
};

export default useWeather;
